import React, { Component } from 'react';
import Section from './Section.js'
import {reduxForm, Field} from 'redux-form';
import { withRouter } from 'react-router';
import {FormattedHTMLMessage} from 'react-intl';
import CustomAlert from './CustomAlert.js';
import RenderField from './RenderField.js';
import CustomSpinner from './CustomSpinner.js';
import withAuthControl from '../auth/Auth.js';
import validate from './Validations/submitValidationsCooperativeRepresentativesForm.js'

class CooperativeRepresentativesForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
            initialForm: false
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        const representatives = [1,2,3]

        const renderRepresentatives = representatives.map((representative, index)=>(
            <div key={representative}>
                <h4> {index + 1}° Representante</h4>
                <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                        <Field className="form-control" name={`representative[${index}].name`} autoComplete="off" component={RenderField} type='text' label="Nombre y Apellido" />
                    </div>
                </div>
                <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                        <Field className="form-control" name={`representative[${index}].cuil`} autoComplete="off" component={RenderField} type='cuil' label="CUIL" />
                    </div>
                </div>
            </div>
        ))

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)} />
                        <FormattedHTMLMessage id="app.step_cooperative_representatives" description="Representatives cooperative" />
                    </div>
                    <div className="pd-content-right text-center col-sm-12 col-md-7 col-lg-7">
                        {this.state.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá.... Por favor espere...' />}
                        <div>
                            <form onSubmit={handleSubmit(this.props.validateCooperativeRepresentatives)} className='pvc-form'>
                                {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' />}
                                {error && <CustomAlert bsStyle="danger" message={error} />}
                                <div className="row">
                                {renderRepresentatives}
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Continuar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

CooperativeRepresentativesForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

CooperativeRepresentativesForm = reduxForm({
    form: 'CooperativeRepresentativesForm', // a unique name for this form
    validate,
    initialValues: {
        representative: [{}, {}, {}]
    }
})(CooperativeRepresentativesForm);

CooperativeRepresentativesForm = withRouter(CooperativeRepresentativesForm);

CooperativeRepresentativesForm = withAuthControl(CooperativeRepresentativesForm);

export default CooperativeRepresentativesForm;



/** WEBPACK FOOTER **
 ** ./src/components/CooperativeRepresentativesForm.js
 **/